<div>
    <div class="container">
        <div class="row mt-5">
            <div class="col-4"><button class="btn btn-secondary me-3" (click)="openModal()" type="submit"><fa-icon [icon]="['fas', 'stamp']"></fa-icon> Certificado DD.JJ.</button></div>
            <div class="col-4"></div>
            <div class="col-4"></div>
        </div>
    </div>
    <div class="container" id="contentToConvert">
        <div class="row mt-5">
        </div>
        <div class="row">
            <div class="col-4">
                <div [innerHTML]="params.titulo_1"></div>
                <div [innerHTML]="params.titulo_2"></div>
                <div [innerHTML]="params.titulo_3"></div>
            </div>
            <div class="col-4">
            </div>
            <div class="col-4 text-end">
                <div [innerHTML]="params.fecha_actual"></div>
            </div>
        </div>
        <div class="row">
            <div class="col-8">
            </div>
            <div class="col-4">
                <div [innerHTML]="params.nro_certificado"></div>
            </div>
        </div>
        <div class="row">
            <div class="col-4">
            </div>
            <div class="col-4 mt-3 mb-2 fw-bold">
                <div [innerHTML]="params.titulo_certificado"></div>
            </div>
            <div class="col-4">
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div [innerHTML]="params.texto_1"></div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <table class="table table-hover mt-3">
                    <thead>
                        <tr>
                            <th scope="col">Periodo</th>
                            <th scope="col">Honorario Bruto</th>
                            <th scope="col">Retención Normal</th>
                            <th scope="col">3% Devolución Préstamo Tasa 0</th>
                            <th scope="col">Factor Anual</th>
                            <th scope="col">Honorarios Bruto Actualizada</th>
                            <th scope="col">Reten. Normal Actualizada</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of periodos">
                            <th scope="row">{{ item.periodo }}</th>
                            <td class="text-end">${{ item.honorario_bruto | number:'':'es'}}</td>
                            <td class="text-end">${{ item.retencion_normal | number:'':'es'}}</td>
                            <td class="text-end">${{ item.retencion_adicional | number:'':'es'}}</td>
                            <td class="text-center">{{ item.factor_actualizacion }}</td>
                            <td class="text-end">${{ item.honorario_bruto_act | number:'':'es'}}</td>
                            <td class="text-end">${{ item.retencion_normal_act | number:'':'es'}}</td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <th scope="row"> TOTAL</th>
                            <td class="text-end">${{ params.total_honorario_bruto | number:'':'es'}}</td>
                            <td class="text-end">${{ params.total_retencion_normal | number:'':'es'}}</td>
                            <td class="text-end">${{ params.total_retencion_adicional | number:'':'es'}}</td>
                            <td></td>
                            <td class="text-end">${{ params.total_honorario_bruto_act | number:'':'es'}}</td>
                            <td class="text-end">${{ params.total_retencion_normal_act | number:'':'es'}}</td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                {{ params.texto_2 }}
            </div>
        </div>
        <div class="row">
            <div class="col-5">
            </div>
            <div class="col-2">
            </div>
            <div class="col-5 text-center">
                {{ params.representante_legal }}
                <br/>
                {{ params.rut_representante_legal }}
                <br/>
                {{ params.cargo_representante_legal }}
            </div>
        </div>
    </div>
</div>  
<div class="row mt-5">
    <div class="col-5">
    </div>
    <div class="col-2">
        <button class="btn btn-primary col-5" (click)="GenerarPDF()">Generar PDF</button>
    </div>
    <div class="col-5">
    </div>
</div> 

